import React from 'react';
import WrongEmailMessage from 'components/helpers/wrong_email_message';
import WrongEmailSent from 'components/newsletters/wrongEmailSent';

const SubscriptionLinks = ({linkText, isDoi, isSuccess, classes, container, redesign, showLink}) => {
  return redesign && isSuccess && !isDoi && <WrongEmailSent />;

  return isSuccess && !isDoi && <WrongEmailMessage classes={classes} />;
};

export default SubscriptionLinks;
